import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { DEFAULT_CONFIG } from '../constants';
import { RestClient } from '../rest-client';
import { logException } from '../sentry/main';
import { removeDuplicateRecommendations } from './utils';
var PRODUCT_RECCOMENDATIONS = '/v1/product-recommendations';
var PRODUCT_JOIN_OR_REQUEST_BULK = '/v1/access-requests/bulk/request';
var ALL_SUPPORTED_PRODUCTS = ['confluence', 'jira', 'jira-core', 'jira-servicedesk', 'jira-software', 'jira-incident-manager', 'jira-product-discovery', 'opsgenie', 'statuspage', 'avocado', 'townsquare', 'compass', 'avp', 'beacon', 'mercury'];
export var InvitationsClient = /*#__PURE__*/function (_RestClient) {
  _inherits(InvitationsClient, _RestClient);
  var _super = _createSuper(InvitationsClient);
  function InvitationsClient(serviceUrl, config) {
    _classCallCheck(this, InvitationsClient);
    return _super.call(this, {
      serviceUrl: serviceUrl,
      config: config
    });
  }
  _createClass(InvitationsClient, [{
    key: "getProductRecommendationsInner",
    value: function () {
      var _getProductRecommendationsInner = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var supportedProducts,
          capabilities,
          orgId,
          queryProducts,
          productQueryParams,
          capabilityQueryParams,
          url,
          _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              supportedProducts = _args.length > 0 && _args[0] !== undefined ? _args[0] : ALL_SUPPORTED_PRODUCTS;
              capabilities = _args.length > 1 ? _args[1] : undefined;
              _context.prev = 2;
              orgId = this.getOrgId();
              queryProducts = supportedProducts && supportedProducts.length > 0 ? supportedProducts : ALL_SUPPORTED_PRODUCTS;
              productQueryParams = queryProducts.map(function (product) {
                return "product=".concat(product);
              }).join('&');
              capabilityQueryParams = capabilities && capabilities.length > 0 ? '&' + capabilities.map(function (capability) {
                return "capability=".concat(capability);
              }).join('&') : '';
              url = "".concat(PRODUCT_RECCOMENDATIONS, "?orgId=").concat(orgId, "&").concat(productQueryParams).concat(capabilityQueryParams);
              _context.next = 10;
              return this.getResource(url);
            case 10:
              return _context.abrupt("return", _context.sent);
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](2);
              this.logException(_context.t0, 'An error occurred while getting product recommendations.');
              throw _context.t0;
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 13]]);
      }));
      function getProductRecommendationsInner() {
        return _getProductRecommendationsInner.apply(this, arguments);
      }
      return getProductRecommendationsInner;
    }()
  }, {
    key: "getProductRecommendations",
    value: function () {
      var _getProductRecommendations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var supportedProducts,
          capabilities,
          result,
          deduplicatedResult,
          _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              supportedProducts = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : ALL_SUPPORTED_PRODUCTS;
              capabilities = _args2.length > 1 ? _args2[1] : undefined;
              _context2.next = 4;
              return this.getProductRecommendationsInner(supportedProducts, capabilities);
            case 4:
              result = _context2.sent;
              _context2.prev = 5;
              deduplicatedResult = removeDuplicateRecommendations(result);
              return _context2.abrupt("return", deduplicatedResult);
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](5);
              this.logException(_context2.t0, 'An error occurred while deduplicating product recommendations.');
              throw _context2.t0;
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[5, 10]]);
      }));
      function getProductRecommendations() {
        return _getProductRecommendations.apply(this, arguments);
      }
      return getProductRecommendations;
    }()
  }, {
    key: "joinOrRequestDefaultAccessToProductsBulk",
    value: function () {
      var _joinOrRequestDefaultAccessToProductsBulk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(simplifiedRequest) {
        var resources, request;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(simplifiedRequest.productAris.length === 0)) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return", Promise.resolve([]));
            case 2:
              _context3.prev = 2;
              resources = simplifiedRequest.productAris.map(function (ari) {
                return {
                  ari: ari,
                  role: 'product/member'
                };
              });
              request = {
                resources: resources,
                note: simplifiedRequest.note,
                accessMode: simplifiedRequest.accessMode,
                source: simplifiedRequest.source
              };
              _context3.next = 7;
              return this.postResource(PRODUCT_JOIN_OR_REQUEST_BULK, request);
            case 7:
              return _context3.abrupt("return", _context3.sent);
            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](2);
              this.logException(_context3.t0, 'An error occurred while joining or requesting access to products.');
              throw _context3.t0;
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[2, 10]]);
      }));
      function joinOrRequestDefaultAccessToProductsBulk(_x) {
        return _joinOrRequestDefaultAccessToProductsBulk.apply(this, arguments);
      }
      return joinOrRequestDefaultAccessToProductsBulk;
    }()
  }]);
  return InvitationsClient;
}(RestClient);

// eslint-disable-next-line import/no-anonymous-default-export
export default new InvitationsClient(DEFAULT_CONFIG.invitationsServiceUrl, {
  logException: logException
});